import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Rectificatif } from '../models/Rectificatif';
@Component({
  selector: 'app-rectificatif',
  templateUrl: './rectificatif.component.html'
})
export class RectificatifComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'Rectificatif'
  @Input() parentForm: FormGroup;
  	@Input() rectificatif : Rectificatif;

  constructor() { }

  public ngOnInit() {  }


  addtypeInfosRectif(){
		//this.rectificatif.infosRectif.push(new TypeInfosRectif());
    this.rectificatif.infosRectif.push(new String());
	}

  removetypeInfosRectif(i){
		this.rectificatif.infosRectif.splice(i, 1);
	}



  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }


}

